/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VirtualMachineAgentsBatchResponse {
    getFixupPrototypeFunction() { return VirtualMachineAgentsBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<VirtualMachineAgentsBatchResponse>): VirtualMachineAgentsBatchResponse {
        let obj = Object.assign(new VirtualMachineAgentsBatchResponse(), model);
        VirtualMachineAgentsBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VirtualMachineAgentsBatchResponse>): VirtualMachineAgentsBatchResponse {
        if (!model) return null;
        return VirtualMachineAgentsBatchResponse.newInstance(<VirtualMachineAgentsBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VirtualMachineAgentsBatchResponse) {
        if (!obj) return;

        models.VirtualMachineAgentsBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VirtualMachineAgentsBatchResponse): boolean {
        Object.setPrototypeOf(obj, VirtualMachineAgentsBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.VirtualMachineAgentSummary.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.VirtualMachineAgentSummary; };

}
